document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll('.swatch.Color[data-value="gold"]').forEach(function(el){
    el.style.background = 'linear-gradient(135deg, #D4AF37, #FFF1A8, #B8860B)';
    el.style.backgroundColor = 'transparent';
  });
});
(function () {
  function applyGold() {
    document.querySelectorAll('.swatch.Color[data-value="gold"]').forEach(function (el) {
      el.style.setProperty(
        'background',
        'linear-gradient(135deg, #D4AF37, #FFF1A8, #B8860B)',
        'important'
      );
      el.style.setProperty('background-color', 'transparent', 'important');
    });
  }

  // Initial run
  applyGold();

  // Observe DOM changes (Corano JS override ko catch karne ke liye)
  const observer = new MutationObserver(function () {
    applyGold();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['style']
  });
})();
